import { getDateAfter } from "./utils";

export const getDaysBetween = (startDt, endDt) => {
  if (!startDt || !endDt || endDt < startDt) {
		return []
	}

	let startDt_date = new Date(startDt);
	let endDt_date = new Date(endDt);

	let days = [];
	let dt = startDt_date;
	
	while (dt <= endDt_date) {
		days.push(dt);
		dt = getDateAfter(dt, 1);
	}

	return days;
}